import Vue from 'vue';
import Vuex from 'vuex';
import { $sg_getShopCarNum } from "@/api/goods";
import { $sg_getUserInfo } from "@/api/user";

Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
  },
  state: {
    cartNum: 0,
    loginInfo: {
      hasLogin: false,
      isTouristOpen: 0,
      isTouristDisplayPrice: 0,
    },
    userInfo: {
      account: ''
    }
  },
  getters: {
	  getLoginInfo: state => state.loginInfo
  },
  actions: {
    async updateCartNum({ commit }) {
      await $sg_getShopCarNum().then(res=>{
        commit('setCartNum', res)
      })
    },
    async updateUserInfo({ commit }) {
      await $sg_getUserInfo().then(res=>{
        // 2026-0615-1530 和小程序端一致
        if (res.usrPlatform) {
          res.clientVO.name = res.usrPlatform.name;
          res.clientVO.phone = res.usrPlatform.account
        }
        commit('setUserInfo', {
          isMicroWarehouseUser: res.isMicroWarehouseUser,
          isEnjoyDiscount: res.isEnjoyDiscount,
          ...res.clientVO,
          ...res.clientFundInfoVO,
        })
      })
    }
  },
  mutations: {
    setCartNum(state, data) {
      state.cartNum = data
    },
    setLoginInfo(state, data) {
      state.loginInfo = data
      localStorage.setItem('shop_login_info', JSON.stringify(data))
    },
    setUserInfo(state, data) {
      state.userInfo = data
    }
  },
});
